/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Total_MinInputs */

const en_editor_total_min = /** @type {(inputs: Editor_Total_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (min)`)
};

const de_editor_total_min = /** @type {(inputs: Editor_Total_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt (Min.)`)
};

/**
* | output |
* | --- |
* | "Total (min)" |
*
* @param {Editor_Total_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_total_min = /** @type {((inputs?: Editor_Total_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Total_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_total_min(inputs)
	return en_editor_total_min(inputs)
});